export class RegistrationUser {
  user_name: string;
  sub: string;
  name: string;
  shop_id: string;
  email: string;
  password?: string;
  role: string;
}
